export function findTutorialTarget(selector, root = document) {
  if (!selector) return null;
  return Array.from(root.querySelectorAll(selector)).find((node) => {
    if (!node.isConnected) return false;
    const style = window.getComputedStyle(node);
    const rect = node.getBoundingClientRect();
    return style.display !== "none"
      && style.visibility !== "hidden"
      && Number(style.opacity || 1) !== 0
      && rect.width > 0
      && rect.height > 0;
  }) || null;
}
